import { RegistrationNoticesType } from "../../types/commonTypes/registrationNoticesType";

export const initialRegistrationNoticesState: RegistrationNoticesType = {
  numberProvided: 'bordereau',
  bordereau: {
    numeroBordereau: '',
    numeroCase: '',
    numeroExtrait: '',
  },
  dossier: null,
};
